/**
 * Trade credit refresh - polls API to refresh customer credit limit.
 * Only runs when enable_trade_features is true and trade_credit_api_url is set.
 */
(function() {
  const apiUrl = window.tradeCreditApiUrl;
  if (!apiUrl || !window.customerId) return;

  function checkRefreshCredit() {
    const lastUpdated = localStorage.getItem('creditLimitLastUpdated');

    if (!lastUpdated) {
      refreshCredit();
      return;
    }

    const lastUpdatedDate = new Date(lastUpdated);
    const currentDate = new Date();
    const diff = currentDate - lastUpdatedDate;
    const minutes = Math.floor(diff / 60000);

    if (minutes >= 30) {
      refreshCredit();
    }
  }

  async function refreshCredit() {
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          shopifyCustomerId: window.customerId
        })
      });

      if (!response.ok) {
        throw new Error('Response returned ' + response.status);
      }

      localStorage.setItem('creditLimitLastUpdated', new Date().toISOString());
    } catch (error) {
      console.error('Error fetching credit limit:', error.message);
    }
  }

  document.addEventListener('DOMContentLoaded', checkRefreshCredit);
})();
